export enum FunctionUsageRange {
    TwentyFourHours = '24h',
    ThirtyDays = '30d',
    NinetyDays = '90d',
}